import React, { useState } from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  src: string;
  alt: string;
  maxWidth?: string;
  // 플레이스홀더가 차지할 높이 — 실제 이미지가 들어와도 레이아웃이 크게 튀지 않도록 맞춘다.
  placeholderHeight?: string;
}

/**
 * 가이드의 예시 이미지.
 *
 * 전달서 §2가 지정한 파일들은 아직 저장소에 없다. 파일이 없는 동안에도 화면이 깨지지 않도록
 * 로드 실패 시 회색 플레이스홀더로 대체한다 — `public/images/` 에 같은 이름으로 파일을 넣으면
 * 코드 수정 없이 그대로 이미지가 표시된다.
 */
function PathPickStartGuideExampleImage({
  src,
  alt,
  maxWidth,
  placeholderHeight = "240px",
}: Props) {
  const { t } = useI18nHelper();
  const [hasFailed, setHasFailed] = useState(false);

  if (hasFailed) {
    return (
      <Flex
        role={"img"}
        aria-label={alt}
        alignItems={"center"}
        justifyContent={"center"}
        width={"100%"}
        maxWidth={maxWidth}
        height={placeholderHeight}
        borderRadius={"4px"}
        border={"1px dashed #D4D4D1"}
        backgroundColor={"#F7F7F5"}
        padding={"16px"}
      >
        <Text
          textStyle={"body-sm-medium"}
          color={"#8F8F8C"}
          textAlign={"center"}
        >
          {t("path_pick_guide:image_placeholder")}
        </Text>
      </Flex>
    );
  }

  return (
    <Box
      width={"100%"}
      maxWidth={maxWidth}
      borderRadius={"4px"}
      overflow={"hidden"}
      border={"0.5px solid #E5E5E3"}
      backgroundColor={"#FFFFFF"}
    >
      <Image
        src={src}
        alt={alt}
        width={"100%"}
        objectFit={"contain"}
        onError={() => setHasFailed(true)}
      />
    </Box>
  );
}

export default PathPickStartGuideExampleImage;
